import { IFieldSchema } from "./IFieldSchema";
import { ControlType } from "../../types/ControlType";

class CField {

    private $schema: IFieldSchema;

    constructor(schema: IFieldSchema) {
        this.$schema = schema;
    }

    get id(): string {
        return this.$schema.id;
    }

    get controlType(): ControlType {
        return this.$schema.controlType;
    }

    get order(): number {
        return this.$schema.order;
    }

    cast<T>(): T {
        return this as any;
    }

    toString(): string {
        return this.controlType.toString();
    }

}

export default CField;